import PropTypes from 'prop-types';

export default PropTypes.shape({
	id: PropTypes.number,
	name: PropTypes.string,
	isExternal: PropTypes.oneOf([1, 0, true, false])
});
